import React from 'react';
import {
  ChatRequestsList,
  ChatRequestItem,
  ChatRequestItemInfo,
  ChatRequestItemName,
  ChatRequestItemConnectId,
  EmptyRequestsMessage,
} from '../../styles/UserWorkspacePageStyles';

const listStyle = {
  maxHeight: 'none',
  overflowY: 'visible',
};

const itemStyle = (isSelected) => ({
  cursor: 'pointer',
  opacity: isSelected ? 1 : 0.85,
});

const checkboxStyle = {
  marginRight: '10px',
  flexShrink: 0,
  cursor: 'pointer',
};

const ContactSelectList = ({
  contacts,
  selectedConnectIds,
  onToggleContact,
  emptyMessage = 'no contacts available',
}) => {
  const selectedSet = new Set(selectedConnectIds || []);

  if (!contacts || contacts.length === 0) {
    return <EmptyRequestsMessage>{emptyMessage}</EmptyRequestsMessage>;
  }

  return (
    <ChatRequestsList style={listStyle}>
      {contacts.map((contact) => {
        const isSelected = selectedSet.has(contact.connect_id);
        return (
          <ChatRequestItem
            key={contact.connect_id}
            style={itemStyle(isSelected)}
            onClick={() => onToggleContact(contact.connect_id)}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={() => onToggleContact(contact.connect_id)}
              onClick={(e) => e.stopPropagation()}
              style={checkboxStyle}
            />
            <ChatRequestItemInfo>
              <ChatRequestItemName>{contact.name || 'user'}</ChatRequestItemName>
              <ChatRequestItemConnectId>id: {contact.connect_id}</ChatRequestItemConnectId>
            </ChatRequestItemInfo>
          </ChatRequestItem>
        );
      })}
    </ChatRequestsList>
  );
};

export default ContactSelectList;
